import React from 'react'
import { Spinner } from 'react-bootstrap'

const LoadingAnimation = (props: { text: string, additionalInfo?: string }) => {
  const { text, additionalInfo } = props
  return (
    <div
      className='d-flex flex-column align-items-center mt-3'
    >
      <h1>
        <Spinner animation='border' variant='primary' />
      </h1>
      <h4>{text}</h4>
      {
        additionalInfo &&
        <p className="text-muted small">{additionalInfo}</p>
      }
    </div>
  )
}

export default LoadingAnimation
